import React from 'react';
import B from 'bem-cn';

import './index.scss';

const cl = B('Login');

export default function Login() {
  return (
    <div className={cl}>
      <strong>Please get in touch with us for a login to:</strong><br />
      Demos |
      User interface
    </div>
  );
}



// WEBPACK FOOTER //
// ../src/components/login/index.jsx